import React, { Component } from 'react';

export default class Pen extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  render() {
    return (
      <svg
        {...this.props}
        version="1.1"
        id="Capa_1"
        x={0}
        y={0}
        viewBox={'0 0 512.002 512.002'}
      >
        <g id="g4" fill={'#ffffff'}>
          <path
            d="M480.002,144.002L368.004,32.003l32-32l111.998,111.999L480.002,144.002z M448,175.999l-16,176c-144,0-352,160-352,160   l-26.565-26.565l136.832-136.831c5.487,2.184,11.467,3.396,17.733,3.396c26.51,0,48-21.49,48-48s-21.49-48-48-48s-48,21.49-48,48   c0,6.266,1.213,12.245,3.397,17.732L26.565,458.564L0,431.999c0,0,160-208,160-352l176-16L448,175.999z"
            id="path2"
            fill={this.props.color}
          />
        </g>
        <g id="g6"></g>
        <g id="g8"></g>
        <g id="g10"></g>
        <g id="g12"></g>
        <g id="g14"></g>
        <g id="g16"></g>
        <g id="g18"></g>
        <g id="g20"></g>
        <g id="g22"></g>
        <g id="g24"></g>
        <g id="g26"></g>
        <g id="g28"></g>
        <g id="g30"></g>
        <g id="g32"></g>
        <g id="g34"></g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/apps/receptions/assets/pen.js